module.exports = __webpack_public_path__ + "img/project9_12.png.56fc8d75.webp";